import Vue from 'vue'

/**
 * Whether the email AI notes card is hidden - the person's choice, kept on
 * this device for every email. Hidden means gone entirely; "Show AI notes"
 * brings it back.
 */
const KEY = 'oms.ai_notes_hidden'

function read() {
  try {
    return window.localStorage.getItem(KEY) === '1'
  } catch (e) {
    return false
  }
}

const pref = Vue.observable({hidden: read()})

export default {
  get hidden() {
    return pref.hidden
  },

  set(hidden) {
    pref.hidden = !!hidden
    try {
      window.localStorage.setItem(KEY, hidden ? '1' : '0')
    } catch (e) {
      // private mode: it lasts until the app is closed
    }
  },
}
